import { AIInput } from '@components/AIInput';
import { AISidebar } from '@components/Holly';

export function Transport() {
  return (
    <div>
      <AIInput />
      <AISidebar />
    </div>
  );
}
